import { breakpoints } from 'static-components/src/breakpoint-constants';
var Tabs = /** @class */ (function () {
    function Tabs() {
    }
    Tabs.deactivateLabels = function (labels) {
        if (labels !== void 0) {
            for (var labelsIndex = 0; labelsIndex < labels.length; labelsIndex++) {
                labels[labelsIndex].className =
                    labels[labelsIndex].className.replace(/(?:^|\s)is-active(?!\S)/, '');
            }
        }
    };
    Tabs.setActiveLabel = function (label) {
        label.classList.add('is-active');
    };
    Tabs.deactivateRadio = function (inputRadio) {
        inputRadio.checked = false;
    };
    Tabs.getTabsContentHeightMobile = function (tabsContent) {
        if (breakpoints().breakpoints.mobile) {
            var topValue = Math.floor(tabsContent.getBoundingClientRect().top);
            var footerElement = document.querySelector(this.flyoutFooterSelector);
            var footerHeight = Math.floor(footerElement.getBoundingClientRect().height);
            return 'calc(100vh - ' + topValue + 'px - ' + footerHeight + 'px)';
        }
        return 'auto';
    };
    Tabs.flyoutFooterSelector = '.js-search-flyout-footer';
    return Tabs;
}());
export default Tabs;
